import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body pt-0" }
const _hoisted_5 = { class: "badge badge-light" }
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`badge badge-light-success`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTDatatable = _resolveComponent("KTDatatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('my_orders')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (Object.keys(_ctx.orders).length > 0)
        ? (_openBlock(), _createBlock(_component_KTDatatable, {
            key: 0,
            "table-data": _ctx.orders,
            "table-header": _ctx.headerConfig,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-id": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.id), 1)
            ]),
            "cell-event_name": _withCtx(({ row: id }) => [
              _createTextVNode(_toDisplayString(id.project_event_name), 1)
            ]),
            "cell-billing": _withCtx(({ row: id }) => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(id.amount) + " Դ", 1)
            ]),
            "cell-seats_count": _withCtx(({ row: id }) => [
              _createTextVNode(_toDisplayString(id.seat_count), 1)
            ]),
            "cell-entrance_count": _withCtx(({ row: id }) => [
              _createTextVNode(_toDisplayString(id.entrance_count), 1)
            ]),
            "cell-date": _withCtx(({ row: id }) => [
              _createTextVNode(_toDisplayString(id.created_at), 1)
            ]),
            "cell-tickets": _withCtx(({ row: id }) => [
              _createTextVNode(_toDisplayString(id.tickets), 1)
            ]),
            "cell-status": _withCtx(({ row: id }) => [
              _createElementVNode("div", _hoisted_6, " success " + _toDisplayString(id.status), 1)
            ]),
            _: 1
          }, 8, ["table-data", "table-header"]))
        : _createCommentVNode("", true)
    ])
  ]))
}